import React, { useState } from 'react';
import Data from '../../Data/Data.json'
import { Button, Typography, Spin } from 'antd';
import Table from '../TableResizable';
import { useNavigate } from 'react-router-dom';
import { Backspace, Print } from '@mui/icons-material';
import { Box, ButtonGroup, Button as ButtonI } from '@mui/material';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png";
import ExcelIcon from '../../Res/ExcelIcon.svg';
import PageNotFound from '../../Pages/PageNotFound';
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';

const PrintListOpeCai = () => {
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.tabListcaiss) ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabListcaiss) + "") : null as any)
    const navigate = useNavigate();
    const [DataExcel, SetDataExcel] = useState<any[]>([]);

    // USER SESSION
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    //loading Boutton  
    const [loading, setLoading] = useState(false);
    const _exporter = React.createRef<ExcelExport>();
    const exportExcel = () => {
        SetDataExcel([]);
        setLoading(true);

        tab?.data.map((data: any, indice: any) => {
            DataExcel.push({
                key: indice,
                DATOPE: data.DATOPE ? data.DATOPE : '',
                NUMSEQ: data.NUMSEQ,
                MONTAN: data.MONTAN ? ReformatNumber(data.MONTAN) : '',
                NUMCPT: data.NUMCPT,
                NUMRAP: data.NUMRAP,
                SENS:data.SENSOP,
                LIBOPE: data.LIBOPE,
                REMETT: data.REMETT,
                cniremet: data.cniremet,
                TYPE: data.TYPE,
                UTISAI: data.UTISAI,
                UTIVAL: data.UTIVAL
            })
        })

        if (!_exporter.current) {
            return;
        }
        _exporter.current.save();
    };

    const handleExport = () => {
        setLoading(false);
    }

    setTimeout(() => {
        if (tab == null) {

        }
    }, 2000)

    return (
        <div><br />
            {tab ?
                <>
                    <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                        <Box className='backBtnt' zIndex={2} onClick={() => {
                            navigate("/transaction/brouillardJour");
                        }}><Backspace /></Box>

                        <ExcelExport filterable data={DataExcel} fileName={"ListingCaisse"+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"}  ref={_exporter} onExportComplete={handleExport}>
                            <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={200} />
                            <ExcelExportColumn field="NUMSEQ" title="Reference" locked={true} />
                            <ExcelExportColumn field="LIBOPE" title="Libelle" />
                            <ExcelExportColumn field="SENS"   title="SENS" />
                            <ExcelExportColumn field="MONTAN" title="Montant" />
                            <ExcelExportColumn field="NUMCPT" title="NUMCPT" />
                            <ExcelExportColumn field="NUMRAP" title="NUMRAP" />
                            <ExcelExportColumn field="REMETT" title="REMETTANT" />
                            <ExcelExportColumn field="TYPE" title="TYPE" />
                            <ExcelExportColumn field="UTISAI" title="UTISAI" />
                            <ExcelExportColumn field="UTIVAL" title="UTIVAL" />
                        </ExcelExport>

                        <Box marginLeft={'1%'} className={"preview_print"}>
                            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                                <img className='printLogo' src={Logo} width={80} />
                                <Typography style={{ textAlign: 'center', marginLeft: '35%' }} className='textTitle'><b>LISTING DES OPERATIONS CAISSE </b></Typography >
                                <hr className='hide' />
                                <Box display={'flex'} gap={'1em'} marginLeft={'30%'}>
                                    <Button title='Imprimer ( ctrl + p )' style={{ padding: 0, margin: 0 }} onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                                    <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                                        <ButtonI id='ExelExport' onClick={exportExcel} disabled={tab.data.length >= 1 ? false : true}> <img style={{ width: '50%', padding: 0, margin: 0 }} src={ExcelIcon} className='ExelExport'></img> </ButtonI>
                                    </ButtonGroup>

                                </Box>
                            </Box><br />
                            <Box display={"flex"} fontStyle="inherit">
                                <Box width={"50%"} >
                                    {/* <Box width={"120%"} display={"flex"}><Typography>Agence : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{user.codage}</b> {user.agence}</Typography></Box> */}
                                    <Box width={"120%"} display={"flex"}><Typography>AGENCE : </Typography><Typography style={{ marginLeft: '4%' }} ><b>{tab?.form?.Agence} </b> {tab?.form?.lib_Agence}</Typography></Box>
                                    <hr />
                                </Box>
                                <Box width={"30%"} marginTop={'-1%'}>
                                    <Typography style={{ textAlign: 'center' }} > <b>{"Période Allant Du " + (new Date(tab?.form?.DateDebut)).toLocaleDateString("fr") + " Au " + " " + (new Date(tab?.form?.DateFin)).toLocaleDateString("fr")}</b> </Typography>
                                </Box>
                                <Box style={{ marginLeft: '5%' }} width={"50%"}>
                                    {/* <Box className='haut' width={"120%"} display={"flex"}><Typography >{"Imprimé par " + user.codage + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Solde Disponible :</Typography> <Typography className='textRight'><b>{tab?.Dispon + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""} </b></Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Blocage :</Typography> <Typography className='textRight'><b>{tab?.form?.BLOQUE + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""}  </b></Typography></Box> */}
                                    <Box width={"120%"} display={"flex"}><Typography>CAISSE:</Typography> <Typography style={{ marginLeft: '4%' }}><b>{tab?.form?.NODECE + " "} {tab.form.lib_NODECE ? tab.form.lib_NODECE : ""}  </b></Typography></Box>
                                </Box>
                            </Box>
                            <Table size='small' showHeader bordered={true} pagination={false} columns={tab?.columns} dataSource={tab.data} />
                            <Box display={"flex"} sx={{ marginLeft: '35%' }} gap={5} >
                                <Typography > <b>Total  / Nombre Débit : </b> <b>{tab?.form?.TotalDebit + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}  </b> / {tab?.form?.Nbrdebit}  </Typography>
                                <Typography > <b>Total  / Nombre Crédit : </b> <b>{tab?.form?.TotalCrebit + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}</b> / {tab?.form?.NbrCrebit}</Typography>
                            </Box  >

                            {/* <Box sx={{ marginLeft: '35%' }}>
                                <Typography  > <b>Solde de Fermeture du compte au {tab?.form?.lastop} : {tab.data[tab.data.length - 1].SOLDT + " "}{tab.form.CDDEVS ? tab.form.CDDEVS : ""}</b></Typography>
                            </Box> 
                           */}
                        </Box>
                    </Spin>
                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/"} texttButton={"Back to situation client"} />}
        </div >
    );
};

export default PrintListOpeCai;